import { useCallback, useEffect } from "react";

const useEscape = (f: () => void) => {
  const handleEsc = useCallback((event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      f();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [handleEsc]);
};

export default useEscape